/* ==========================================================================
   PanelVehicle > Select
   ========================================================================== */

/* Modules */
const SelectClient = require('../../../select/client/js');
const { updateUi } = require('./ui');

/* Init Select */
function initSelect(selector, configuration, instance) {
    /* Return select instance */
    return SelectClient(selector, {
        ...configuration,
        enableClick: true,
        choices: {
            searchEnabled: false
        },
        onChange: [() => updateUi(instance), select => configuration.onChangeSelect(select, instance)]
    });
}

module.exports = {
    initSelect
};
